export default __webpack_public_path__ + "static/media/Scope-2.27e91d60.png";